/**
 * Persian short connector words — these take tight spacing in Nastaliq
 * typography (که، از، به …). Canonical home of the list; `src/constants`
 * re-exports it for the V1 typography rules.
 */
export const PERSIAN_SHORT_CONNECTORS: readonly string[] = [
  'که', 'از', 'به', 'با', 'تا', 'در', 'را', 'و', 'یا', 'هم',
  'چه', 'کی', 'می', 'نه', 'ای', 'اگر', 'اما', 'ولی', 'پس',
  'زیر', 'روی', 'بر', 'تو', 'ما', 'او', 'آن', 'این',
]
